import React from 'react';
import I18n from 'i18n-js';
import { convertCurrency } from '../convert_currency';
import {
  reverb_config_cache_ExchangeRate,
  core_apimessages_Money,
} from '../rql';
import SanitizedRender from '../components/sanitized_render';
import { RCTooltip } from '../rc/RCTooltip';

export interface IProps {
  userCurrency: string;
  shopCurrency: string;
  shippingPrice?: core_apimessages_Money; // always in seller's currency
  offerAmount: string;
  rates: reverb_config_cache_ExchangeRate[];
}

export default class OffersCurrencyConversion extends React.Component<IProps> {
  convertAmount(amount) {
    return convertCurrency(
      this.props.userCurrency,
      this.props.shopCurrency,
      this.props.rates,
      amount,
    ).display;
  }

  formatAmount(price) {
    const currency = this.props.shopCurrency;
    const spanOpen = '<span class="size-80 weight-normal">';
    const spanClose = '</span>';
    return `${price} ${spanOpen}${currency}${spanClose}`;
  }

  offerApproximation(offerAmount, shippingPrice) {
    const convertedOfferAmount = this.convertAmount(offerAmount);

    if (shippingPrice) {
      return I18n.t('commons.offers.currencyApproximation', {
        offerAmount: this.formatAmount(convertedOfferAmount),
        shippingPrice: this.formatAmount(shippingPrice.display),
      });
    }

    return I18n.t('commons.offers.currencyApproximationUnknownShipping', {
      offerAmount: this.formatAmount(convertedOfferAmount),
    });
  }

  render() {
    const { offerAmount, shippingPrice, shopCurrency, userCurrency } = this.props;
    const tooltipText = I18n.t('commons.offers.sellerCurrencyWarning', {
      shopCurrency,
      userCurrency,
    });

    if (!offerAmount) {
      return null;
    }
    if (userCurrency === shopCurrency) {
      return null;
    }

    return (
      <section className="offers-currency-conversion">
        <h1 className="offers-currency-conversion__title">
          <SanitizedRender
            html={this.offerApproximation(offerAmount, shippingPrice)}
          />
        </h1>
        <p>
          <RCTooltip text={tooltipText}>
            {I18n.t('commons.offers.valueMayVary', { userCurrency, shopCurrency })}
          </RCTooltip>
        </p>
      </section>
    );
  }
}
